import React from "react";
import { Modal, Table, Avatar, Spin } from "antd";
import { UserOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { BrandThemeProvider } from "../../../../ui";

/**
 * RankingModal — ranking del quiz activo por alumno (Itinerarios, F4).
 */
export function RankingModal({
  open,
  onClose,
  loading,
  rankingQuizName,
  rankingData = [],
  classNumber,
}) {
  const { t } = useTranslation("evaluations");

  const columns = [
    {
      title: "#",
      key: "pos",
      width: 48,
      render: (_v, _r, i) => i + 1,
    },
    {
      title: t("evaluationGrid.colStudent"),
      key: "student",
      render: (_v, item) => (
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <Avatar size={28} src={item.avatar} icon={<UserOutlined />} />
          <div>
            <div style={{ fontWeight: 600, lineHeight: 1.2 }}>
              {item.studentName}
            </div>
            <div style={{ fontSize: 12, color: "#6b7280" }}>{classNumber}</div>
          </div>
        </div>
      ),
    },
    {
      title: t("evaluationGrid.colCorrect"),
      dataIndex: "totalCorrect",
      key: "correct",
      width: 100,
      align: "center",
    },
    {
      title: t("evaluationGrid.colIncorrect"),
      dataIndex: "totalIncorrect",
      key: "incorrect",
      width: 100,
      align: "center",
    },
    {
      title: t("evaluationGrid.colTime"),
      dataIndex: "timeTaken",
      key: "time",
      width: 100,
      align: "center",
    },
  ];

  return (
    <BrandThemeProvider>
      <Modal
        open={open}
        onCancel={onClose}
        centered
        width={640}
        title={`${t("evaluationGrid.rankingForQuiz")}: ${rankingQuizName || ""}`}
        footer={null}
      >
        {loading ? (
          <div
            style={{
              display: "grid",
              placeItems: "center",
              padding: 32,
              gap: 10,
            }}
          >
            <Spin />
            <span style={{ color: "#6b7280" }}>
              {t("evaluationGrid.rankingLoading")}
            </span>
          </div>
        ) : (
          <Table
            rowKey={(r) => r.studentId}
            columns={columns}
            dataSource={rankingData}
            pagination={false}
            size="small"
          />
        )}
      </Modal>
    </BrandThemeProvider>
  );
}

export default RankingModal;
